import React, { useEffect, useRef } from 'react'
import { BsX } from 'react-icons/bs'
import './styles.css'
import clsx from 'clsx'

const NoAuthModal = (props) => {
  const timeoutRef = useRef(null)

  const onGoToLogin = () => {
    props.changeToLogin()
    props.onClose()
  }

  useEffect(() => {
    if (props.open) {
      timeoutRef.current = setTimeout(() => {
        if (props.onClose) {
          props.onClose()
        }
      }, 5000)
    }

    return () => {
      clearTimeout(timeoutRef.current)
    }
  }, [props, props.onClose, props.open])

  return (
    <div
      className={clsx(
        'fixed z-30 w-full max-w-md no-expanded-login-modal transition-all duration-200 ease-in-out',
        props.open ? 'bottom-0' : '-bottom-52'
      )}
      style={{
        height: '9rem',
      }}
    >
      <div className='w-full h-full relative'>
        <button className='absolute cursor-pointer top-5 right-3 opacity-0 50' onClick={props.onClose}>
          <BsX className='w-8 h-8' />
        </button>
        <div className='absolute w-full bottom-6 left-0 flex flex-row justify-start items-center text-white'>
          <button className='cursor-pointer underline text-xl font-bold' onClick={onGoToLogin} style={{ marginLeft: '52%' }}>
            Entre para ler
          </button>
        </div>
      </div>
    </div>
  )
}

export default NoAuthModal
